import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthShell from '../components/auth/AuthShell';
import AuthCard from '../components/auth/AuthCard';
import useAuthActions from '../components/auth/useAuthActions';

export default function LoginPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const [mode, setMode] = useState('login');
  const [prefilledUsername, setPrefilledUsername] = useState('');
  const [showAuthRequired, setShowAuthRequired] = useState(false);

  const {
    loading,
    error,
    success,
    clearMessages,
    handleLogin,
    handleSignup,
  } = useAuthActions();

  useEffect(() => {
    if (location.state?.from === 'auth-required') {
      setShowAuthRequired(true);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.pathname, location.state, navigate]);

  const onModeChange = (next) => {
    setMode(next);
    clearMessages();
    setShowAuthRequired(false);
  };

  const onSignup = (formData) => {
    handleSignup(formData, (username) => {
      setPrefilledUsername(username);
      setMode('login');
    });
  };

  return (
    <AuthShell
      subtitle="Secure clinical access for authorized healthcare professionals and administrators."
    >
      <AuthCard
        mode={mode}
        onModeChange={onModeChange}
        loading={loading}
        error={error}
        success={success}
        onLogin={handleLogin}
        onSignup={onSignup}
        prefilledUsername={prefilledUsername}
        showAuthRequired={showAuthRequired}
      />
    </AuthShell>
  );
}
